/**
 * Feature Flag Configuration
 * Controls which features are enabled/disabled in the application
 */

export interface FeatureFlags {
  // Core Features
  CHARACTER_SHEET: boolean;
  COMBAT_PAGE: boolean;
  ADVANCEMENT_PAGE: boolean;
  SETTINGS_PAGE: boolean;
  SHOP_PAGE: boolean;
  GM_PAGE: boolean;

  // Storage Features
  GOOGLE_DRIVE: boolean;

  // Test Features
  GOOGLE_DRIVE_TESTS: boolean;

  // Development Features
  FEATURE_TOGGLES: boolean;
}

// Default feature configuration
export const DEFAULT_FEATURES: FeatureFlags = {
  // Start with basic features enabled
  CHARACTER_SHEET: true, // Enable character sheet feature
  COMBAT_PAGE: true, // Enable combat page feature
  ADVANCEMENT_PAGE: true,
  SETTINGS_PAGE: true, // Enable settings page feature
  SHOP_PAGE: true, // Enable shop feature
  GM_PAGE: true, // Enable GM combat tracker (bestiary, encounter builder and runner)

  // Storage features
  GOOGLE_DRIVE: true,

  // Test features - always enabled for debugging
  GOOGLE_DRIVE_TESTS: true,

  // Development features
  FEATURE_TOGGLES: true
};

// Feature descriptions for UI
export const FEATURE_DESCRIPTIONS: Record<keyof FeatureFlags, string> = {
  CHARACTER_SHEET: 'Character creation and management interface',
  COMBAT_PAGE: 'Combat interface with dice rolling and initiative tracking',
  ADVANCEMENT_PAGE: 'Character advancement and experience spending',
  SETTINGS_PAGE: 'Application settings and configuration',
  SHOP_PAGE: 'Equipment shop for browsing and selecting items',
  GM_PAGE: 'GM combat tracker: bestiary, encounter builder and runner',
  GOOGLE_DRIVE: 'Google Drive cloud storage integration',
  GOOGLE_DRIVE_TESTS: 'Google Drive integration test pages',
  FEATURE_TOGGLES: 'Runtime feature toggle controls'
};

// Feature categories for organization
export const FEATURE_CATEGORIES = {
  CORE: [
    'CHARACTER_SHEET',
    'COMBAT_PAGE',
    'ADVANCEMENT_PAGE',
    'SETTINGS_PAGE',
    'SHOP_PAGE',
    'GM_PAGE'
  ] as (keyof FeatureFlags)[],
  STORAGE: ['GOOGLE_DRIVE'] as (keyof FeatureFlags)[],
  TESTING: ['GOOGLE_DRIVE_TESTS'] as (keyof FeatureFlags)[],
  DEVELOPMENT: ['FEATURE_TOGGLES'] as (keyof FeatureFlags)[]
};
